import angular from 'angular'
import canonicalUrlComponent from './headline.component'

export default angular
  .module('ellipsis.headline', [])
  .component('headline', canonicalUrlComponent)
